import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors, Button, Grid, Card, CardContent, CardHeader, Divider } from '@mui/material';
import { Page, Header, Alert, FilePicker, FilesDropzone } from 'components';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../components/ModalDialog/ModalDialog.js';
import { SetFormState, XcapToolAttachmentsUpload, ToggleXcapToolDialog } from '../../actions/DualMapActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const XcapToolFilesUploadDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.dualMapReducer.formState);
	const userId = useSelector(state => state.session.user.id);

	const _addAttachments = (files) => {
		files.forEach(file => {
			if (!file.size > 50000000) {
				dispatch(enqueueSnackbar({ message: `File size${file.name} cannot be superior to 50MB`, options: { variant: 'warning' } }));
			}
		});
		dispatch(XcapToolAttachmentsUpload(userId, files));
		dispatch(ToggleXcapToolDialog(false));
		// dispatch(enqueueSnackbar({ message: 'Files uploaded', options: { variant: 'info' } }));
	};

	return (
		<ModalDialog
			// maxWidth="xs"
			onClose={onClose}
			open={open}
			title="XCAP Tool"
			// confirmLabel="Ok"
			hasConfirm={false}
		// onConfirmClicked={_onConfirmClick}
		>
			<div className={classes.fields}>
				<Card className={classes.container} container spacing={3}>
					{/* <CardHeader title="Upload" /> */}
					<Divider />
					<CardContent>
						<FilesDropzone
							acceptedTypes=".csv"
							upload={_addAttachments}
						/>
					</CardContent>
				</Card>
			</div>

		</ModalDialog>
	);
};

XcapToolFilesUploadDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired
};

export default XcapToolFilesUploadDialog;
